import React from "react";
import { Avatar, Box, Typography, LinearProgress, Stack } from "@mui/material";
import { red, blue, green, deepPurple, orange } from "@mui/material/colors";

const TalkTimeRatio = ({ name, time, percentage, color, transcript = [], totalDuration = 0 }) => {
  const percentValue = parseFloat(percentage);

  // Calculate speaker segments from transcript
  const speakerSegments = React.useMemo(() => {
    if (!transcript || transcript.length === 0 || !totalDuration) return [];
    
    return transcript
      .filter(t => t.speaker === name)
      .map(t => ({
        start: t.start_time || 0,
        end: t.end_time || t.start_time || 0
      }));
  }, [transcript, name, totalDuration]);

  return (
    <Box sx={{ mb: 3 }}>
      {/* Top Row */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Avatar + Name + Subtitle */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Avatar sx={{ bgcolor: color, width: 32, height: 32, fontSize: 14 }}>
            {name?.[0]?.toUpperCase() || "?"}
          </Avatar>
          <Box>
            <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{name}</Typography>
          </Box>
        </Box>

        {/* Right side percentage */}
        <Typography sx={{ color: "#666", fontWeight: 500, fontSize: 13 }}>
          {percentage} ({time})
        </Typography>
      </Box>

      {/* Timeline with segments */}
      <Box sx={{ mt: 1, position: "relative", height: 8, background: "#f0f0f0", borderRadius: 1 }}>
        {speakerSegments.map((segment, idx) => {
          const startPercent = (segment.start / totalDuration) * 100;
          const widthPercent = ((segment.end - segment.start) / totalDuration) * 100;
          return (
            <Box
              key={idx}
              sx={{
                position: "absolute",
                left: `${startPercent}%`,
                width: `${widthPercent}%`,
                height: "100%",
                background: color,
                borderRadius: 0.5
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default TalkTimeRatio;
